"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryCatch = void 0;
const immutable_1 = require("immutable");
const option_1 = require("./option");
const tryCatch = (f, fallback) => (a) => {
    const results = (0, immutable_1.List)(Array.isArray(f) ? f : [f])
        .map(f => f(a))
        .flatMap((l, n, i) => (0, option_1.listFromOption)(l));
    if (results.isEmpty())
        return fallback(a);
    return results.first();
};
exports.tryCatch = tryCatch;
